import styled from 'styled-components'

interface IMembersListStyledProps {
  rows: number
}

export const MembersListStyled = styled.ul<IMembersListStyledProps>`
  display: grid;
  grid-template-rows: repeat(${(props) => props.rows}, auto);
  grid-auto-flow: column;
  column-gap: ${(props) => props.theme.space.medium};
  row-gap: ${(props) => props.theme.space.small};
`
